module.exports = __webpack_public_path__ + "files/f4243204fbd66a0027c2d16511b196a5.png";